import { diffBetweenDateTimes } from 'modules/core/lib/dates'

interface Conversation {
  conversationStatus?: {
    lastReadAt?: string | null
  } | null
  lastMessage?: {
    createdAt: string
  } | null
}

export const isConversationRead = (conversation: Conversation) =>
  !!conversation.conversationStatus?.lastReadAt &&
  diffBetweenDateTimes(
    conversation.conversationStatus!.lastReadAt,
    conversation.lastMessage!.createdAt
  ) >= 0

export const isConversationUnread = (conversation: Conversation) =>
  !isConversationRead(conversation)
